import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#066542",
      d: "M18.872 8.226a.735.735 0 0 1 1.06 0 .787.787 0 0 1 0 1.09l-7.25 7.458a.735.735 0 0 1-1.06 0l-7.25-7.457a.787.787 0 0 1 0-1.091.735.735 0 0 1 1.06 0l6.72 6.912z"
    }, null, -1)
  ]))]))
}
export default { render: render }